import { randomUuid } from './lib/random-uuid';

/** Durable conversation metadata returned by the company thread API. */
export interface ThreadMeta {
  id: string;
  title: string;
  updatedAt: number;
}

export function newThreadId(): string {
  return randomUuid();
}

/** Return a renamed server thread list without inventing a local row. */
export function withThreadTitle(threads: ThreadMeta[], id: string, title: string): ThreadMeta[] {
  return threads.map((thread) => (thread.id === id ? { ...thread, title } : thread));
}
